import { CustomComponent, DateUtil, initComponents } from './common';
import { CustomInputComponent } from './custom-input';
import { NestedInputComponent } from './nested-input';
import { OtherFieldComponent } from './other-field';
import { SelectAllComponent } from './select-all';
import { TemporalComponent } from './temporal-component';
import { TimeInputComponent } from './time-input';
import { TimeRangeComponent, TimeRangeDisplayComponent } from './time-range';
import { TimeSelectorComponent } from './time-selector';

export * from './common';
export * from './custom-input';
export * from './nested-input';
export * from './other-field';
export * from './temporal-component';
export * from './time-input';
export * from './time-range';
export * from './time-selector';

export interface DesignSystemStatic {
  initComponents: typeof initComponents;

  CustomComponent: typeof CustomComponent;
  CustomInputComponent: typeof CustomInputComponent;
  DateUtil: typeof DateUtil;
  NestedInputComponent: typeof NestedInputComponent;
  OtherFieldComponent: typeof OtherFieldComponent;
  SelectAllComponent: typeof SelectAllComponent;
  TemporalComponent: typeof TemporalComponent;
  TimeInputComponent: typeof TimeInputComponent;
  TimeRangeComponent: typeof TimeRangeComponent;
  TimeRangeDisplayComponent: typeof TimeRangeDisplayComponent;
  TimeSelectorComponent: typeof TimeSelectorComponent;
}

declare global {
  interface Window {
    iwDesignSystem: DesignSystemStatic;
  }
}

window.iwDesignSystem = {
  initComponents,
  CustomComponent,
  CustomInputComponent,
  DateUtil,
  NestedInputComponent,
  OtherFieldComponent,
  SelectAllComponent,
  TemporalComponent,
  TimeInputComponent,
  TimeRangeComponent,
  TimeRangeDisplayComponent,
  TimeSelectorComponent,
}
